import {
  isFacebookWebView,
  isInstagramWebView,
  recordEvent,
  trackLogInfo,
  trackMetricCount,
} from './observability';

type TrackingPayload = Record<string, unknown>;

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    uetq?: { push?: (...args: unknown[]) => void } | unknown[];
  }
}

export const trackEvent = (eventName: string, payload: TrackingPayload = {}) => {
  try {
    const browser = isInstagramWebView()
      ? 'instagram'
      : isFacebookWebView()
        ? 'facebook'
        : 'browser';

    const context = {
      ...payload,
      browser,
      source: 'tracking',
      eventName,
    };

    trackMetricCount(`ux.click.${eventName}`, context);

    // Mantém compatibilidade com os painéis existentes que usam funnel.*
    recordEvent(eventName as any, context);

    trackLogInfo(`flow.${eventName}`, context);
  } catch (err) {
    // ignore sentry logging failures
  }

  if (typeof window === 'undefined') return;

  try {
    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', eventName, payload);
    }
  } catch (err) {
    // ignore Meta Pixel failures
  }
};

export const trackMetaPixelEvent = (eventName: string, payload: TrackingPayload = {}) => {
  if (typeof window === 'undefined') return;

  try {
    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', eventName, payload);
    }
  } catch (err) {
    // ignore Meta Pixel failures
  }
};

export const trackMicrosoftUetEvent = (eventName: string, payload: TrackingPayload = {}) => {
  if (typeof window === 'undefined') return;

  try {
    const tracker = (window as any).uetq;
    if (tracker && typeof tracker.push === 'function') {
      tracker.push('event', eventName, payload);
      return;
    }

    if (Array.isArray(tracker)) {
      tracker.push(['event', eventName, payload]);
    }
  } catch (err) {
    // ignore Microsoft UET failures
  }
};
